import { render, staticRenderFns } from "./ManageALF.vue?vue&type=template&id=2c55c2ee"
import script from "./ManageALF.vue?vue&type=script&lang=js"
export * from "./ManageALF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports